import { Document } from '@contentful/rich-text-types';

import { parseRichText } from '@libs/contentful';

import { useProduct } from '@/entities/product';
import { useVetRxContentQuery } from '@/entities/vet-rx-content';
import { getVetRxDrawerData } from '@/widgets/product-details/specialty/lib';

const DISCLAIMER_BY_TYPE = {
    cold: 'Cold RX Disclaimer',
    rx_med: 'RX Disclaimer',
} as const;

export const PurchaseDisclaimer = () => {
    const { product } = useProduct();
    const { vetRx = [] } = useVetRxContentQuery();

    const { coldStorage, type } = product?.pharmacy || {};

    const disclaimerType = (coldStorage && 'cold') || (type === 'rx_med' && 'rx_med') || null;
    if (!disclaimerType) return null;

    const disclaimerContent = getVetRxDrawerData(vetRx, disclaimerType).body.find(
        item => item.fields?.internalTitle === DISCLAIMER_BY_TYPE[disclaimerType]
    )?.fields?.content as Document | undefined;

    if (!disclaimerContent) return null;

    return <div className="purchase-form__disclaimer">{parseRichText(disclaimerContent)}</div>;
};
